(function () {
    'use strict';

    function sortColumn() {
        return {
            restrict: 'A',
            templateUrl: 'common/directives/templates/sortColumn.html',
            scope: {
                columnName: '@',
                activeSortDirection: '=',
                activeSortColumnName: '=',
                sortClick: '&'
            },
            link: function (scope, element, attrs) {
                scope.changeSort = function () {

                }
            }
        };
    }

    sortColumn.$inject = [];

    angular.module('ecap.common').directive('sortColumn', sortColumn);
})();